module.exports = __webpack_public_path__ + "img/bg_purple.17db7cae.jpg";